<template>
  <label :for="uid" class="flex items-center gap-2 bg-white px-3 py-2 text-sm">
    <SearchIcon class="h-4 w-4 !text-[#cacbd3]" :class="iconClasses" />
    <input
      :id="uid"
      type="text"
      :value="value"
      class="text-p-yellow-600 flex-1 appearance-none border-none bg-transparent p-0 focus:outline-none focus:ring-0"
      :placeholder="placeholder"
      @input="onInput"
    />
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SearchIcon from '~/assets/icons/SearchReportIcon.svg'
import type { TSearchVariant } from '~/src/types/markets'

const props = withDefaults(
  defineProps<{
    value?: string
    placeholder?: string
    variant?: TSearchVariant
  }>(),
  {
    value: '',
    placeholder: 'Search...',
    variant: 'default',
  },
)

const emit = defineEmits(['input'])
const uid = `search-${useId()}`

const iconClasses = computed(() => ({
  'text-white/90': props.variant === 'default',
  'text-p-yellow-600': props.variant === 'country-search',
}))

const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('input', target.value)
}
</script>

<style scoped>
.input {
  background: linear-gradient(
      0deg,
      rgb(255 255 255 / 9%) 0%,
      rgb(255 255 255 / 9%) 100%
    ),
    #071830;
}
</style>
